const details = [
  {
    memberId: 'CC 101',
    memberName: 'Patricia Payne',
    insuranceName: "UnitedCare",
    conversationCount: 2,
    callCategory: "Claim Denial",
    meetingPerson: "Paul",
    meetingDate: "15-June-2024",
    duration: "35 Minute",
    callType: "Inbound",
    urgency: "High",
    sections: [
      { title: "Reason for Conversation", content: "Patricia Payne called to change her meal selections." },
      { title: "Summary of the Conversation", content: "Patricia wanted to update her meal order." },
      { title: "Root Cause of the Issue", content: "The issue is related to a misunderstanding of the order process." },
      { title: "Problem Resolution", content: "The issue was resolved by confirming the new order selections." },
      { title: "Next Steps", content: "No further action required." },
      { title: "Customer Feedback", content: "Patricia was satisfied with the resolution." },
      { title: "Follow-up Required", content: "No follow-up needed." }
    ]
  },
  {
    memberId: 'CC 102',
    memberName: 'John Smith',
    insuranceName: "UnitedCare",
    conversationCount: 2,
    callCategory: "Claim Denial",
    meetingPerson: "Paul",
    meetingDate: "15-June-2024",
    duration: "35 Minute",
    callType: "Inbound",
    urgency: "High",
    sections: [
      { title: "Reason for Conversation", content: "John Smith had a billing issue with his account." },
      { title: "Summary of the Conversation", content: "John inquired about a duplicate charge on his bill." },
      { title: "Root Cause of the Issue", content: "A system error caused the duplicate charge." },
      { title: "Problem Resolution", content: "The charge was refunded, and the error was corrected." },
      { title: "Next Steps", content: "Monitoring the account for future billing issues." },
      { title: "Customer Feedback", content: "John appreciated the quick resolution." },
      { title: "Follow-up Required", content: "Follow-up in a week to confirm no further issues." }
    ]
  },
  {
    memberId: 'CC 103',
    memberName: 'Linda Williams',
    insuranceName: "UnitedCare",
    conversationCount: 2,
    callCategory: "Claim Denial",
    meetingPerson: "Paul",
    meetingDate: "15-June-2024",
    duration: "35 Minute",
    callType: "Inbound",
    urgency: "High",
    sections: [
      { title: "Reason for Conversation", content: "Sarah Lee wanted to update her address on file." },
      { title: "Summary of the Conversation", content: "Sarah requested to change her mailing address." },
      { title: "Root Cause of the Issue", content: "Her previous address was outdated." },
      { title: "Problem Resolution", content: "The address was successfully updated in the system." },
      { title: "Next Steps", content: "Confirm delivery of future correspondence to the new address." },
      { title: "Customer Feedback", content: "Sarah was happy with the service." },
      { title: "Follow-up Required", content: "No follow-up needed." }
    ]
  },
  {
    memberId: 'CC 104',
    memberName: 'Michael Davis',
    insuranceName: "UnitedCare",
    conversationCount: 2,
    callCategory: "Claim Denial",
    meetingPerson: "Paul",
    meetingDate: "15-June-2024",
    duration: "35 Minute",
    callType: "Inbound",
    urgency: "High",
    sections: [
      { title: "Reason for Conversation", content: "Michael Jordan requested a status update on his claim." },
      { title: "Summary of the Conversation", content: "Michael was informed of the current claim review process." },
      { title: "Root Cause of the Issue", content: "The claim is under review due to missing documents." },
      { title: "Problem Resolution", content: "Requested the missing documents to proceed." },
      { title: "Next Steps", content: "Follow-up once documents are received." },
      { title: "Customer Feedback", content: "Michael appreciated the transparency." },
      { title: "Follow-up Required", content: "Follow-up in two days." }
    ]
  },
  {
    memberId: 'CC 105',
    memberName: 'James Anderson',
    insuranceName: "UnitedCare",
    conversationCount: 2,
    callCategory: "Claim Denial",
    meetingPerson: "Paul",
    meetingDate: "15-June-2024",
    duration: "35 Minute",
    callType: "Inbound",
    urgency: "High",
    sections: [
      { title: "Reason for Conversation", content: "Lisa Brown inquired about a denied claim." },
      { title: "Summary of the Conversation", content: "Lisa was concerned about a recent claim denial." },
      { title: "Root Cause of the Issue", content: "The claim was denied due to incomplete information." },
      { title: "Problem Resolution", content: "Clarified the required information for resubmission." },
      { title: "Next Steps", content: "Resubmit the claim with complete information." },
      { title: "Customer Feedback", content: "Lisa felt reassured after the conversation." },
      { title: "Follow-up Required", content: "Follow-up in a week to confirm resubmission." }
    ]
  },
  {
    memberId: 'CC 106',
    memberName: 'Karen Lee',
    insuranceName: "UnitedCare",
    conversationCount: 2,
    callCategory: "Claim Denial",
    meetingPerson: "Paul",
    meetingDate: "15-June-2024",
    duration: "35 Minute",
    callType: "Inbound",
    urgency: "High",
    sections: [
      { title: "Reason for Conversation", content: "David Wilson asked for an update on a pending claim." },
      { title: "Summary of the Conversation", content: "David was informed that the claim is still under investigation." },
      { title: "Root Cause of the Issue", content: "The claim processing is delayed due to verification." },
      { title: "Problem Resolution", content: "Advised to wait until the verification is complete." },
      { title: "Next Steps", content: "Monitor the claim for updates." },
      { title: "Customer Feedback", content: "David expressed concern but agreed to wait." },
      { title: "Follow-up Required", content: "Follow-up in two days with any updates." }
    ]
  },
  {
    memberId: 'CC 107',
    memberName: 'David Moore',
    insuranceName: "UnitedCare",
    conversationCount: 2,
    callCategory: "Claim Denial",
    meetingPerson: "Paul",
    meetingDate: "15-June-2024",
    duration: "35 Minute",
    callType: "Inbound",
    urgency: "High",
    sections: [
      { title: "Reason for Conversation", content: "Emily Davis had a question about her denied claim." },
      { title: "Summary of the Conversation", content: "Emily was seeking clarity on the denial reasons." },
      { title: "Root Cause of the Issue", content: "The denial was due to missing documentation." },
      { title: "Problem Resolution", content: "Explained the missing documents needed for approval." },
      { title: "Next Steps", content: "Resubmit the claim with the required documents." },
      { title: "Customer Feedback", content: "Emily was appreciative of the detailed explanation." },
      { title: "Follow-up Required", content: "Follow-up in a week to ensure resubmission." }
    ]
  }
];

export default [
  {
    memberId: "",
    memberName: "",
    insuranceName: "",
    conversationCount: 1,
    callCategory: "",
    meetingPerson: "",
    meetingDate: "",
    duration: "",
    callType: "",
    urgency: "",
    sections: [
      { title: "", content: "" },
      { title: "", content: "" },
      { title: "", content: "" },
      { title: "", content: "" },
      { title: "", content: "" },
      { title: "", content: "" },
      { title: "", content: "" },
    ],
  },
];
